import { customDateParserForGuard } from './customDateParserForGuard';
import { enhanceChecklistData } from './enhanceChecklistData';
import { mapBackendStatusToFrontEndStatus } from './mapPatrolStatus';

export function convertToPatrolData(
	data: any,
	patrolInfo: ScheduleAssignment,
	updateDurationOnSave: boolean,
): PatrolData {
	const updated_timestamps = JSON.parse(data[6]); // contains the updated timestamps for patrol begin and end time
	const patrolData: PatrolData = {
		patrolInfo: {
			...patrolInfo,
			started: true, // Mark as started when patrol data is loaded (guard is working on it)
			comment_list_id: data[2],
			patrol_begin_time: customDateParserForGuard(
				updated_timestamps[0].start_date,
			),
			patrol_end_time: customDateParserForGuard(
				updated_timestamps[0].end_date,
			),
		},
		comment: data[1],
		status: mapBackendStatusToFrontEndStatus(
			data[3],
		) as PatrolGeneralStatus,
		checklists: enhanceChecklistData(data[4] as PatrolChecklist[]),
		attachments: data[5],
		updateDurationOnSave,
	};
	return patrolData;
}
